





























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOrderData } from '@/api/types'
import { sortByNumber, sortByDate, sortByString } from '@/utils/sort'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'OrderTable'
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  list!: Array<IOrderData>;

  @Prop({
    type: Number,
    default: () => {
      return 0
    }
  })
  total!: number;

  @Prop({ type: Boolean })
  listLoading = true;

  get getTotal() {
    return this.total || 0
  }

  get getListLoading() {
    return this.listLoading
  }

  get totalPages() {
    if (this.total === 0) return 0
    return this.total / this.pageSize
  }

  get getPageSize() {
    return this.pageSize || 20
  }

  setPageSize(val: number) {
    this.pageSize = val
  }

  get getPageNumber() {
    return this.pageNumber || 1
  }

  handleSortData(sort: any) {
    // debugger
    if (this.list && this.list.length !== 0) {
      this.list = this.list.sort((a, b) => {
        const result = sort.column.sortMethod(a, b)
        return sort.order === 'ascending' ? result : result * (-1)
      })
      this.handleCurrentChange(1)
    }
  }

  handleCurrentChange(val: number) {
    console.log(`current page: ${val}`)
    this.pageNumber = val
  }

  private handleCurrentPageSync = 1;
  // Number of Rows per Page for Pagination
  private pageSize = 20;
  private pageNumber = 1;

  get pagedTableData() {
    if (!this.list || this.list.length === 0) return []
    return this.list.slice(this.pageSize * this.pageNumber - this.pageSize, this.pageSize * this.pageNumber)
  }

  sortOrderId(a: IOrderData, b: IOrderData): number {
    return sortByNumber(a.orderId, b.orderId)
  }

  sortOrderType(a: IOrderData, b: IOrderData): number {
    return sortByString(a.orderTypeNavigation.name || '', b.orderTypeNavigation.name || '')
  }

  sortStatusId(a: IOrderData, b: IOrderData): number {
    return sortByString(a.orderStatus, b.orderStatus)
  }

  sortInspectionDate(a: IOrderData, b: IOrderData): number {
    return sortByDate(a.inspectionDate, b.inspectionDate)
  }

  sortApptDate(a: IOrderData, b: IOrderData): number {
    return sortByDate(a.appointmentDate, b.appointmentDate)
  }

  sortSubjectAddress(a: IOrderData, b: IOrderData): number {
    return sortByString(a.subjectAddress, b.subjectAddress)
  }

  sortSubjectCity(a: IOrderData, b: IOrderData): number {
    return sortByString(a.subjectCity, b.subjectCity)
  }

  sortSubjectState(a: IOrderData, b: IOrderData): number {
    return sortByString(a.subjectState, b.subjectState)
  }

  sortLender(a: IOrderData, b: IOrderData): number {
    return sortByString(a.lenderName, b.lenderName)
  }

  sortClient(a: IOrderData, b: IOrderData): number {
    return sortByString(a.clientName, b.clientName)
  }

  sortInspector(a: IOrderData, b: IOrderData): number {
    return sortByString(this.getVendorName(a), this.getVendorName(b))
  }

  getVendorName(row: IOrderData) {
    if (row !== null) {
      if (row.vendor !== undefined && row.vendor !== null) {
        return row.vendor.lastName + ', ' + row.vendor.firstName
      }
      if (row.inspector !== undefined && row.inspector !== null) {
        return row.inspector.lastName + ', ' + row.inspector.firstName
      }
    }
    return ''
  }

  private dialogDeleteOrder = false;
  private deleteReason = '';
  private deleteOrderId = 0;
  private deleteTitle = ''

  private showDeleteDialog(orderId: number) {
    this.dialogDeleteOrder = true
    this.deleteReason = ''
    this.deleteOrderId = orderId
    this.deleteTitle = 'Cancel/Deactivate Order ' + this.deleteOrderId
  }

  private closeDeleteDialog() {
    this.dialogDeleteOrder = false
  }

  private handleDelete() {
    this.closeDeleteDialog()
    this.$emit('handleDelete', this.deleteOrderId, this.deleteReason)
  }

  private isAdmin() {
    const roles = UserModule.roles
    return roles.includes('Admin')
  }
}
